import { SearchIcon } from '@/components/icons/search-icon';
import { GeoLocationComponent } from '@/components/location/geo-location/geo-location';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { PagedListOfTheater } from '@cinemark/content-api-client';
import { useState } from 'react';
import { MoviesZipCodeSearch } from './movies-zip-code-search';

type MoviesLocationControlsProps = {
  isLoading: boolean;
  onTheaterResults: (
    results: PagedListOfTheater,
    isGeoSearch?: boolean,
    zipCode?: string
  ) => void;
};
export const MoviesLocationControls = ({
  isLoading,
  onTheaterResults,
}: Readonly<MoviesLocationControlsProps>): React.JSX.Element | null => {
  const [isZipDialogOpen, setIsZipDialogOpen] = useState(false);

  if (isLoading) return null;

  return (
    <>
      <GeoLocationComponent mini
        miniButtonVariant="ghost"
        miniIconClassName="icon icon-primary"
        miniText="Near You"
        miniTextClassName="font-bold text-sm max-md:hidden"
        onResults={(results): void => onTheaterResults(results, true)}
      />

      <Button aria-label="Near ZIP Code"
        data-test="movies-zip-search-trigger"
        variant="ghost"
        onClick={(): void => setIsZipDialogOpen(true)}
      >
        <SearchIcon aria-hidden="true"
          className="icon icon-primary"
        />
        <span className="font-bold text-sm max-md:hidden"
          data-test="movies-zip-search"
        >
          Near ZIP Code
        </span>
      </Button>

      <Dialog open={isZipDialogOpen}
        onOpenChange={setIsZipDialogOpen}
      >
        <DialogContent className="w-full md:min-w-[430px] md:max-w-[430px]">
          <DialogHeader>
            <DialogTitle className="sr-only">Search by ZIP Code</DialogTitle>
            <DialogDescription className="sr-only">
              Find Movies near a ZIP code.
            </DialogDescription>
          </DialogHeader>
          <MoviesZipCodeSearch onCancel={(): void => setIsZipDialogOpen(false)}
            onResults={(results, zipCode): void => {
              onTheaterResults(results, false, zipCode);
              setIsZipDialogOpen(false);
            }}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};
